import { Grid, TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import Button from "utils/CustomButtons/Button";
import LoadingOverlay from 'react-loading-overlay';
import ReactLoading from 'react-loading';
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { CallAPI } from "services/API";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

var obj;
export const GWPPP_TransCode = (props) => {
    const isMobile = useMediaQuery('(max-width: 1152px)');
    const isSmallerScreen = useMediaQuery('(max-width: 1900px)');
    const [data, setData] = React.useState([]);
    const [total, setTotal] = React.useState({});
    const [isPP, setIsPP] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [comments, setComments] = React.useState(props.comments?.filter(x => x.table == 'Gross Written Premium') ?? []);

    var nf = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const cellStyle = { fontSize: isMobile ? "0.875rem" : "1.6em", lineHeight: "1.3em", color: "#ff8000", whiteSpace: "nowrap", padding: isMobile ? "16px 4px" : "16px" };
    const headerStyle = { fontSize: isMobile ? "0.85rem" : "1.3em", color: "#1d4c80", fontWeight: "400", padding: isMobile ? "16px 4px" : "16px", width: isMobile ? "100%" : "unset" }

    const RefreshData = async (toggle) => {
        setComments(props.comments?.filter(x => x.table == (toggle ? 'Posted Premium' : 'Gross Written Premium')) ?? []);

        const data = await CallAPI("POST", `/Home/GetGrossWrittenOrPostedPremium`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            isPP: toggle
        });

        if (data?.length > 0) {
            data.forEach(item => {
                if (item.transactionCode.includes("In-Force"))
                    item.tooltip = "As of today's date";
            });

            setData(data.filter(x => x.transactionCode != "Total Premium"));
            setTotal(data.find(x => x.transactionCode == "Total Premium") ?? {});
            setLoading(false);
        }
    }

    const handleIsPP = () => {
        var toggle = !isPP;
        setIsPP(toggle);
        setLoading(true);
        RefreshData(toggle);
    };

    useEffect(() => {
        if (props.call == "true" || props.call == null) {
            setData([]);
            setTotal({});
            setLoading(true);
            RefreshData(isPP);
        }
    }, [props.call]);

    return (
        <div
            style={
                isMobile ?
                    {
                        marginTop: "2em",
                        marginLeft: "0em",
                        marginRight: "0em",
                        backgroundColor: "#f1f1f1"
                    }
                    :
                    {
                        marginTop: "2em",
                        marginLeft: ".5em",
                        marginRight: ".5em",
                        backgroundColor: "#f1f1f1"
                    }
                
            }
        >
            <LoadingOverlay
                active={loading}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        position: "absolute!important"
                    })
                }}
                spinner={<ReactLoading type={'spin'} height={50} width={50} />}
            >
            <Grid container>
                <Grid item
                    xs={12} sm={12} md={12} lg={3}
                    style={{ textAlign: "center" }}
                >
                    <span
                        style={
                            isMobile ?
                                {
                                    fontSize: "1.8em",
                                    color: "#1d4c80",
                                    paddingTop: "1.2em",
                                    paddingBottom: "1em",
                                    paddingLeft: ".4em",
                                    display: "inline-block"
                                }
                                :
                                {
                                    fontSize: "1.6em",
                                    color: "#1d4c80",
                                    paddingTop: "1.2em",
                                    paddingBottom: "1em",
                                    paddingLeft: "1em",
                                    display: "inline-block"
                                }
                        }
                    >
                        {isPP?
                            "POSTED PREMIUM"
                            :
                            "GROSS WRITTEN PREMIUM"
                        }
                    </span>
                </Grid>
                <Grid item
                    xs={12} sm={12} md={12} lg={9}
                    style={ useMediaQuery('(max-width: 1025px)') ?{ textAlign: "center" } : { textAlign: "left" }}
                    >
                        <Button onClick={handleIsPP} style={isSmallerScreen ? { color: 'white', margin: '20px', backgroundColor: '#ff8000' } : { color: 'white', margin: '20px', marginLeft: '12em', backgroundColor: '#ff8000' }} color="primary"> {isPP ? "TOGGLE GWP" : "TOGGLE PP"}</Button>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer style={{ position: "relative", marginTop: "1em", margin: "auto", maxWidth: "850px" }}>
                        <Table style={isMobile ? { maxWidth: 390, tableLayout: 'auto', margin: "auto" } : { minWidth: 650, tableLayout: 'auto' }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={headerStyle}>TRANSACTION CODE</TableCell>
                                    <TableCell style={headerStyle}>TOTAL PREMIUM</TableCell>
                                    <TableCell style={headerStyle}>AGENCY <span style={{ whiteSpace: "nowrap" }}>PREMIUM (%)</span></TableCell>
                                    <TableCell style={headerStyle}>AVERAGE PREMIUM</TableCell>
                                    {comments.length > 0 && <TableCell></TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data.map((row) => {
                                        return (
                                            <TableRow
                                                key={row.transactionCode}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row" style={{ ...headerStyle, ...isMobile ? { fontSize: cellStyle.fontSize } : {} }}>
                                                    {row.transactionCode}
                                                    {row.tooltip && <TooltipButton tooltipText={row.tooltip} />}
                                                </TableCell>
                                                <TableCell style={cellStyle}>
                                                    ${nf.format(row.premium ?? 0)}
                                                </TableCell>
                                                <TableCell style={cellStyle}>
                                                    ${nf.format(row.agencyPremium ?? 0)} ({nf.format(Math.abs(row.agencyPremiumPercentage ?? 0))}<span style={isMobile ? { fontSize: "0.78rem" } : {}}>%</span>)
                                                </TableCell>
                                                <TableCell style={cellStyle}>
                                                    ${nf.format(row.averagePremium ?? 0)}
                                                </TableCell>
                                                {props.comments?.length > 0 && <TableCell style={{ whiteSpace: 'pre-line' }}>{comments.find(x => x.row == row.transactionCode)?.message}</TableCell>}
                                            </TableRow>
                                        );
                                    })
                                }
                                <TableRow key={total.transactionCode}>
                                    <TableCell component="th" scope="row" style={{ ...headerStyle, ...isMobile ? { fontSize: cellStyle.fontSize } : {} }}>
                                        {total.transactionCode}
                                    </TableCell>
                                    <TableCell style={cellStyle}>
                                        ${nf.format(total.premium ?? 0)}
                                    </TableCell>
                                    <TableCell style={cellStyle}>
                                        ${nf.format(total.agencyPremium ?? 0)} ({nf.format(Math.abs(total.agencyPremiumPercentage ?? 0))}<span style={isMobile ? { fontSize: "0.78rem" } : {}}>%</span>)
                                    </TableCell>
                                    <TableCell style={cellStyle}>
                                        N/A
                                    </TableCell>
                                    {props.comments?.length > 0 && <TableCell style={{ whiteSpace: 'pre-line' }}>{comments.find(x => x.row == total.transactionCode)?.message}</TableCell>}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            </LoadingOverlay>

        </div>
    );
}
